import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export const useTwoColumns = makeStyles((theme: Theme) =>
  createStyles({
    twoColumns: {
      display: 'grid',
      gridColumnGap: theme.spacing(5),
      gridTemplateColumns: '1fr 1fr',
      alignItems: 'start',
    },
    twoColumnsAlt: {
      display: 'grid',
      gridColumnGap: theme.spacing(2),
      gridTemplateColumns: '2fr 1fr',
      alignItems: 'start',
    }
  }),
);
